import React from 'react';
import { useMemoizedFn } from 'ahooks';
import { Button } from 'tea-component';
import classnames from 'classnames';
import { Bubble } from '@home/components/TeaComponents';

import type { IBaseProps } from '@home/types/common';

export interface IAddBtnProps extends IBaseProps {
  disabled?: boolean;
  tips?: string | React.ReactElement | null;
  text?: string | React.ReactElement;
  onClick?: () => void;
}
const AddBtn: React.FC<IAddBtnProps> = (props) => {
  const { style, className, disabled = false, tips, text = '+Add', onClick } = props;

  const handleClick = useMemoizedFn((e?: React.SyntheticEvent<Element>) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (disabled) return;
    onClick?.();
  });

  return (
    <div style={style} className={classnames('dbg-addable-table-wrapper__add-btn', className)}>
      <Bubble dark arrowPointAtCenter placement="top" content={tips}>
        <Button type="link" disabled={disabled} onClick={handleClick}>
          {text}
        </Button>
      </Bubble>
    </div>
  );
};

export default React.memo(AddBtn);
